__turbopack_context__.v({
  "bottom": "Footer-module-scss-module__wcgw9G__bottom",
  "cookieButton": "Footer-module-scss-module__wcgw9G__cookieButton" + " " + "Footer-module-scss-module__wcgw9G__link",
  "fade-in": "Footer-module-scss-module__wcgw9G__fade-in",
  "footer": "Footer-module-scss-module__wcgw9G__footer",
  "groupheading": "Footer-module-scss-module__wcgw9G__groupheading",
  "grouplist": "Footer-module-scss-module__wcgw9G__grouplist",
  "link": "Footer-module-scss-module__wcgw9G__link",
  "main": "Footer-module-scss-module__wcgw9G__main",
  "nav": "Footer-module-scss-module__wcgw9G__nav",
  "navgroup": "Footer-module-scss-module__wcgw9G__navgroup",
  "navlink": "Footer-module-scss-module__wcgw9G__navlink" + " " + "Footer-module-scss-module__wcgw9G__link",
  "no-transform": "Footer-module-scss-module__wcgw9G__no-transform",
  "policies": "Footer-module-scss-module__wcgw9G__policies",
  "policieslink": "Footer-module-scss-module__wcgw9G__policieslink" + " " + "Footer-module-scss-module__wcgw9G__link",
  "publisher": "Footer-module-scss-module__wcgw9G__publisher",
  "rotate": "Footer-module-scss-module__wcgw9G__rotate",
});
